// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f9bc99ce","703":"8dc19e5b","787":"cda612ba"}[chunkId] + ".chunk.js";
};